import React from "react"
import VideoSurface from "./util/video-surface"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

export interface PageHeaderProps {
  title?: string
  sectionTitle?: string
  variant?: "has-title" | "dark" | "o-row-mobile" | "headline"
  headerImage?: Queries.PageFieldsFragment["headerImage"]
  headerVideo?: Queries.PageFieldsFragment["headerVideo"]["video"]
}

const PageHeader = (props: PageHeaderProps) => {
  const hasTitle = !!(props.title || props.sectionTitle)
  const headerImage = getImage(props.headerImage)
  const darkBackground = !!headerImage || !!props.headerVideo

  const titleElement = () => {
    switch (true) {
      case !!(props.title && props.sectionTitle):
        return (
          <>
            <p className="c-heading--f">{props.sectionTitle}</p>
            <h1 className="u-visually-hidden">{props.title}</h1>
          </>
        )
      case !!props.title:
        return <h1 className="c-heading--f">{props.title}</h1>
      case !!props.sectionTitle:
        return <p className="c-heading--f">{props.sectionTitle}</p>
    }
  }

  return (
    <section
      className={`c-page-header o-row ${props.variant ? props.variant : ""}${
        darkBackground ? " -dark" : ""
      }${hasTitle ? " -has-title" : ""}`}
    >
      {headerImage && (
        <GatsbyImage
          className="c-page-header__image"
          image={headerImage}
          alt=""
        />
      )}
      {props.headerVideo && <VideoSurface video={props.headerVideo} />}
      {hasTitle && (
        <div className="c-page-header__text-container o-wrapper">
          <div className="o-6-of-12@large u-left@large">{titleElement()}</div>
        </div>
      )}
    </section>
  )
}

export default PageHeader
